import { alpha, darken as muiDarken } from '@mui/material/styles';

export { alpha };

export const darken = (color: string, coefficient: number): string => muiDarken(color, coefficient);
